






























































































import Vue from 'vue';
import Component from 'vue-class-component';

import { LigneCalendrier } from '@/types';

import dateGrossesseService from '@/services/dateGrossesseService.ts';

const Props = Vue.extend({
	props: {
		//ligne calendrier
		ligne: {
			type: Object,
			default: null
		},
		//dpg
		dpg: {
			type: String,
			default: ''
		}
	}
});

/** Une ligne du calendrier **/
@Component
export default class Ligne extends Props {

	dateGrossesseService = dateGrossesseService;

}
